import { Routes } from '@angular/router';
import { Segments } from './shared/constants/routes/routes.constant';
import { HomeComponent } from './modules/home/home.component';
import { LegalNoticeComponent } from './modules/legal-notice/legal-notice.component';

export const routes: Routes = [
  {
    path: Segments.home,
    component: HomeComponent,
  },
  {
    path: Segments.companies,
    loadChildren: () =>
      import('./modules/companies/companies.routes').then(
        (m: typeof import('./modules/companies/companies.routes')) => m.routes
      ),
  },
  {
    path: Segments.employees,
    loadChildren: () =>
      import('./modules/employees/employees.routes').then(
        (m: typeof import('./modules/employees/employees.routes')) => m.routes
      ),
  },
  {
    path: Segments.workStudy,
    loadChildren: () =>
      import('./modules/work-study/work-study.routes').then(
        (m: typeof import('./modules/work-study/work-study.routes')) => m.routes
      ),
  },
  {
    path: Segments.interns,
    loadChildren: () =>
      import('./modules/interns/interns.routes').then(
        (m: typeof import('./modules/interns/interns.routes')) => m.routes
      ),
  },
  {
    path: Segments.students,
    loadChildren: () =>
      import('./modules/students/students.routes').then(
        (m: typeof import('./modules/students/students.routes')) => m.routes
      ),
  },
  {
    path: Segments.selfEmployed,
    loadChildren: () =>
      import('./modules/self-employed/self-employed.routes').then(
        (m: typeof import('./modules/self-employed/self-employed.routes')) =>
          m.routes
      ),
  },
  {
    path: Segments.legalNotice,
    component: LegalNoticeComponent,
  },
];
